import { Controller } from 'stimulus'
import 'summernote'
import Cropper from 'cropperjs';
import cropper from '../../../library/cropper'
import bootbox from 'bootbox'
window.bootbox = bootbox

export default class extends Controller {
  static targets = [
    'amenity',
    'faqs',
    'faqsUi',
    'faqsV2Ui',
    'faqTpl',
    'faqTplUi',
    'faqV2TplUi',
    'faqButton'
  ]
  static values = {
    faqs: String,
    faqsui: String,
    faqsv2ui: String
  };

  connect() {
    //
    this.loadSummernoteEditor()
    this.disabledEnterForm()
    this.modalDeleteSimpleForm()
    //
    this.tags = []
    this.customTags()
    this.appendExistingAmenity()
    //
    this.unitTypeChange()
    //
    //this.minMaxCapacityChange()
    //this.bindingDiscountLimit()
    //
    this.bindingAddDiscount()
    this.bindingDiscountInputs()

    // Room Photos Function
    this.image_selector = $('#media-input-preview #image')
    this.status_selector = $('#media-input-preview #status-image')
    this.id_target, this.target_x, this.target_y, this.target_h, this.target_w,
      this.target_preview, this.value_x, this.value_y, this.value_h, this.value_w,
      this.photo_remote_link, this.photo_remote_link, this.cropperElement = null
    this.photosAdded()
    this.bindingImageUpload()

    // Package Photo
    this.bindingPackageButton()

    this.initSelect2Fields()
    $('#venue_room_allow_cuisine').on('click', function (e) {
      if ($('#venue_room_allow_cuisine').is(":checked")) {
        $("select.select2-wo-order").removeAttr("disabled");
      } else {
        $("select.select2-wo-order").attr("disabled", "disabled");
      }
    });

    this.commissionPrice()
  }

  updateFaqFields(faqs, category, categoryId) {
    const controller = this;
    let html = '';
    let htmlUi = '';
    let htmlUiV2 = '';

    this.updateFaqsCache(faqs);
    this.updateFaqsUiCache(category, categoryId);
    this.updateFaqsV2UiCache(faqs);

    let deletedFaqs = [];
    $.each(this.cachedFaqs, function (index, faq) {
      if (faq.destroy) {
        deletedFaqs.push(faq);
      }
      let tpl = _.template(controller.faqTplTarget.innerHTML);
      html += tpl(faq);
    });
    this.faqsTarget.innerHTML = html;
    $.each(deletedFaqs, function (index, faq) {
      var faqHiddenWrapper = $('.faqs-hidden_wrapper-idx-' + faq.faq_idx);
      var destroy = faqHiddenWrapper.find('.faq-destroy-input');
      destroy.prop('disabled', false);
      destroy.prop('checked', true);
      destroy.attr('checked', 'checked');
      faqHiddenWrapper.addClass('hidden').addClass('removed');
    });

    $.each(this.cachedFaqsUi, function (index, faq) {
      let tplUi = _.template(controller.faqTplUiTarget.innerHTML);
      htmlUi += tplUi(faq);
    });
    this.faqsUiTarget.innerHTML = htmlUi;

    $.each(this.cachedFaqsV2Ui, function (index, faq) {
      let tplUiV2 = _.template(controller.faqV2TplUiTarget.innerHTML);
      htmlUiV2 += tplUiV2(faq);
    });
    this.faqsV2UiTarget.innerHTML = htmlUiV2;

    // if (this.cachedFaqsUi.length > 0) {
    //   this.faqsUiTarget.classList.remove('hidden');
    // } else {
    //   this.faqsUiTarget.classList.add('hidden');
    // }

    if (this.cachedFaqsV2Ui.length > 0) {
      this.faqsV2UiTarget.classList.remove('hidden');
    } else {
      this.faqsV2UiTarget.classList.add('hidden');
    }

    this.updateFaqButtonLabel();
  }

  updateFaqsCache(faqs) {
    let tmp = this.cachedFaqs;
    let merge = (a, b, p) => a.filter(aa => !b.find(bb => aa[p] == bb[p])).concat(b)
    if (tmp == null) { tmp = new Array(); }

    this.faqsValue = JSON.stringify(merge(tmp, faqs, "index"));
  }

  updateFaqsUiCache(category, categoryId) {
    let tmp = this.cachedFaqsUi;
    let merge = (a, b, p) => a.filter(aa => !b.find(bb => aa[p] == bb[p])).concat(b)
    if (tmp == null) { tmp = new Array(); }

    this.faqsuiValue = JSON.stringify(merge(tmp, [{ category_value: category, category_value_to_id: categoryId }], "category_value_to_id"));
  }

  updateFaqsV2UiCache(faqs) {
    let tmp = this.cachedFaqsV2Ui;
    let merge = (a, b, p) => a.filter(aa => !b.find(bb => aa[p] == bb[p])).concat(b)
    if (tmp == null) { tmp = new Array(); }

    let merged = merge(tmp, faqs, "index");
    merged.sort((a, b) => a.index - b.index);

    this.faqsv2uiValue = JSON.stringify(merged);
  }

  deleteFaqsCache(category, categoryId) {
    let tmp = this.cachedFaqs;
    if (tmp == null) { tmp = new Array(); }

    let newFaqs = $.grep(tmp, function (faq) { return faq.category_value_to_id != categoryId; });

    this.faqsValue = JSON.stringify(newFaqs);
  }

  deleteFaqsUiCache(category, categoryId) {
    let tmp = this.cachedFaqsUi;
    if (tmp == null) { tmp = new Array(); }

    let newFaqs = $.grep(tmp, function (faq) { return faq.category_value_to_id != categoryId; });

    this.faqsuiValue = JSON.stringify(newFaqs);
  }

  deleteFaqsV2Cache(faqIdx) {
    let tmp = this.cachedFaqs;
    if (tmp == null) { tmp = new Array(); }
    let deletedFaq = null;

    let newFaqs = $.grep(tmp, function (faq) {
      var cond = faq.faq_idx != faqIdx
      if (!cond && !faqIdx.toString().includes('new')) {
        deletedFaq = faq;
        deletedFaq.destroy = true;
      }
      return cond;
    });

    if (deletedFaq) {
      newFaqs.push(deletedFaq);
    }

    this.faqsValue = JSON.stringify(newFaqs);
  }

  deleteFaqsV2UiCache(faqIdx) {
    let tmp = this.cachedFaqsV2Ui;
    if (tmp == null) { tmp = new Array(); }

    let newFaqs = $.grep(tmp, function (faq) { return faq.faq_idx != faqIdx; });

    this.faqsv2uiValue = JSON.stringify(newFaqs);
  }

  updateFaqButtonLabel() {
    this.faqButtonTarget.innerText = this.cachedFaqs.length > 0 ? 'Add more FAQs' : 'Add FAQ';
  }

  get cachedFaqs() {
    try { return JSON.parse(this.faqsValue); } catch (error) { return null; }
  }

  get cachedFaqsUi() {
    try { return JSON.parse(this.faqsuiValue); } catch (error) { return null; }
  }

  get cachedFaqsV2Ui() {
    try { return JSON.parse(this.faqsv2uiValue); } catch (error) { return null; }
  }

  deleteFaq(event) {
    const contoller = this
    event.preventDefault();
    let category = $(event.currentTarget).closest('.faq-input-wrapper').data('category');
    let categoryId = $(event.currentTarget).closest('.faq-input-wrapper').data('category-id');

    $.each($("#all_faqs").find(`.faq-input-wrapper[data-category="${category}"]`), function () {
      let destroy = $(this).find('.faq-destroy-input');
      destroy.prop('disabled', false);
      destroy.prop('checked', true);
      destroy.attr('checked', 'checked');
      $(this).addClass('hidden').addClass('removed');
      contoller.deleteFaqsCache(category, categoryId)
      contoller.deleteFaqsUiCache(category, categoryId)
    });

    contoller.updateFaqButtonLabel();
  }

  deleteFaqV2(event) {
    const contoller = this
    event.preventDefault();
    let faqIdx = $(event.currentTarget).closest('.faq-input-wrapper').data('faq-idx');

    $.each($("#all_faqs").find(`.faq-input-wrapper[data-faq-idx="${faqIdx}"]`), function () {
      let destroy = $(this).find('.faq-destroy-input');
      destroy.prop('disabled', false);
      destroy.prop('checked', true);
      destroy.attr('checked', 'checked');
      $(this).addClass('hidden').addClass('removed');
      if (destroy.length > 0) {
        contoller.deleteFaqsV2Cache(faqIdx)
        contoller.deleteFaqsV2UiCache(faqIdx)
      }
    });

    contoller.updateFaqButtonLabel();
  }

  commissionPrice() {
    const controller = this;


    // $('#venue_room_room_type').on('change', function (e) {
    //   if ($(this).val() != 'Meeting Room') {
    //     $('input[name="venue_room[is_commission_based]"]').val('false')
    //     $('#chosen_price').html($('#normal_price').html());
    //     $('#package_container').html($('#package_template').html());
    //   } else {
    //     $('input[name="venue_room[is_commission_based]"]').val('true');
    //     $('#chosen_price').html($('#commission_price').html());
    //     $('#package_container').html('');
    //     controller.priceSetup();
    //   }
    // });

    $(document).on('change', '.cleaning-fee-enabled', function() {
      var isChecked = $(this).is(':checked');
      var cleaningFeeContent = $('#cleaning-fee-content');
      var toggleLabel = $(this).siblings('.toggle-label');
      
      if (isChecked) {
        cleaningFeeContent.slideDown();
        toggleLabel.text('Enabled');
      } else {
        cleaningFeeContent.slideUp();
        toggleLabel.text('Disabled');
        // Clear the field when disabled
        cleaningFeeContent.find('input[id*="cleaning_fee"]').val('');
      }
    });

    $(document).on('change', '.registered-gst', function() {
      var isChecked = $(this).is(':checked');
      var toggleLabel = $(this).siblings('.toggle-label');
      
      if (isChecked) {
        toggleLabel.text('Yes');
      } else {
        toggleLabel.text('No');
      }
    });

    document.getElementsByClassName('cleaning-fee-input')[0].addEventListener('input', function (event) {
      this.value = this.value.replace(/[^0-9]/g, '');
    });

    $(".edit input[name='venue_room[is_commission_based]']").on('click', function (e) {
      // Do something interesting here

      var value = $(this).val();

      e.preventDefault();

      bootbox.confirm({
        message: `<h5 class='modal-title text-center'>Change pricing type</h5><p>Changing the pricing type will not lose your all values, so dont't worry. Do you want to continue?</p>`,
        closeButton: false,
        onEscape: true,
        backdrop: true,
        buttons: {
          cancel: {
            label: 'No, keep use this price',
            className: 'btn-orange'
          },
          confirm: {
            label: 'Yes, change the price',
            className: 'btn-shadow'
          },
        },
        callback: result => {
          var room_type = $('#venue_room_room_type').val();
          if (result) {
            if (value == 1) {
              if (room_type == "Meeting Room") {
                $("#" + e.currentTarget.id).prop("checked", true);
                $('#chosen_price').html($('#commission_price').html());
                $('#package_container').html('');
                controller.priceSetup();
              } else {
                bootbox.alert("Commission Price only for Meeting Room.");
              }
            } else {
              $("#" + e.currentTarget.id).prop("checked", true);
              $('#chosen_price').html($('#normal_price').html());
              $('#package_container').html($('#package_template').html());
            }
          }
        }
      });
    });

    $(".new input[name='venue_room[is_commission_based]']").on('click', function (e) {
      // Do something interesting here

      if (e.target.value == '1') {
        e.preventDefault();

        bootbox.confirm({
          message: `<h5 class='modal-title text-center'>Change pricing type</h5><p>This Price only for Meeting Rooms, Are you sure you want to choose this price?</p>`,
          closeButton: false,
          onEscape: true,
          backdrop: true,
          buttons: {
            cancel: {
              label: 'No, nevermind',
              className: 'btn-orange'
            },
            confirm: {
              label: 'Yes, change the price type',
              className: 'btn-shadow'
            },
          },
          callback: result => {
            var room_type = $('#venue_room_room_type').val();
            if (result) {
              if (room_type == "Meeting Room") {
                $("#" + e.currentTarget.id).prop("checked", true);
              } else {
                bootbox.alert("Commission Price only for Meeting Room.");
              }
            }
          }
        });
      }
    });

    controller.priceSetup();
  }

  priceSetup() {
    // Get all day toggle switches
    const dayToggles = document.querySelectorAll('.day-toggle');

    const controller = this;

    // Add event listeners to day toggles
    dayToggles.forEach(toggle => {
      toggle.addEventListener('change', function () {
        const daySection = this.closest('.day-section');
        const day_name = daySection.dataset.value;
        const ratesContainer = daySection.querySelector(`#${day_name}_content`);
        const ratesTemplate = daySection.querySelector(`#${day_name}_template`);
        const toggleLabel = daySection.querySelector('.toggle-label');

        if (this.checked) {
          ratesContainer.innerHTML = ratesTemplate.innerHTML;
          toggleLabel.innerHTML = "Open"
        } else {
          ratesContainer.innerHTML = "";
          toggleLabel.innerHTML = "Closed"
        }

        controller.initAddRateBtn(daySection);
        controller.initPopulateHours(daySection);
        controller.initDeleteButtons(daySection);
        controller.initFullRateBtn(daySection);
        controller.initDeleteFullButtons(daySection);
      });
    });

    this.initAddRateBtn();
    this.initPopulateHours();
    this.initFullRateBtn();

    // Initialize delete buttons
    this.initDeleteButtons();
    this.initDeleteFullButtons();

    // Add validation for min hours and price inputs
    const numberInputs = document.querySelectorAll('input[type="number"]');

    numberInputs.forEach(input => {
      input.addEventListener('input', function () {
        // Ensure value is not negative
        if (this.value < 0) {
          this.value = 0;
        }

        // For min hours, ensure it's at least 1
        if (this.classList.contains('min-hour-input') && this.value < 1) {
          this.value = 1;
        }
      });
    });
  }

  initPopulateHours(newSection = null) {
    // Add functionality to time selects to ensure end time is after start time
    const dayRateContainers = newSection == null ? document.querySelectorAll('.rates-container') : newSection.querySelectorAll('.rates-container');
    const controller = this;

    dayRateContainers.forEach(function (container, i) {
      const rateRows = container.querySelectorAll('.rate-row');

      let openTime = null;

      rateRows.forEach(function (row, j) {
        const timeSelect = row.querySelectorAll('.time-select')
        const startTimeSelect = timeSelect[0];
        const endTimeSelect = timeSelect[1];

        controller.validatePriceInput(row, '.price-input');

        // Populate initially based on default selected start hour
        if (j == 0) {
          controller.populateHours(0, startTimeSelect, controller.splitTimeToOnlyHour(startTimeSelect.dataset.value));
          
          openTime = 25 + parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value));
        } else {
          let firstRow = rateRows[0].querySelectorAll('.time-select');
          const previousRow = rateRows[j - 1].querySelectorAll('.time-select');
          controller.populateOneHour(parseInt(controller.splitTimeToOnlyHour(previousRow[1].dataset.value)), startTimeSelect, controller.splitTimeToOnlyHour(startTimeSelect.dataset.value));

          openTime = 25 + parseInt(controller.splitTimeToOnlyHour(firstRow[0].value));
        }

        controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value)) + 1, endTimeSelect, controller.splitTimeToOnlyHour(endTimeSelect.dataset.value), openTime);

        startTimeSelect.addEventListener('change', function () {
          console.log(1)
          let firstRow_temp = rateRows[0].querySelectorAll('.time-select');
          let openTime_temp;
          if (firstRow_temp != this) {
            openTime_temp = 25 + parseInt(controller.splitTimeToOnlyHour(firstRow_temp[0].value));
          } else {
            openTime_temp = 25 + parseInt(controller.splitTimeToOnlyHour(this.value));
          }

          controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeSelect, null, openTime_temp);

          // Create a new 'change' event
          var event = new Event('change');
          // Dispatch it.
          endTimeSelect.dispatchEvent(event);
        });

        endTimeSelect.addEventListener('change', function () {
          const newRateRows = container.querySelectorAll('.rate-row');
          const firstRow = newRateRows[0].querySelectorAll('.time-select')[0];
          let value = firstRow.value;
          if (firstRow.value == endTimeSelect.value) {
            newRateRows.forEach(function (row, k) {
              if (newRateRows.length > 1 && k > j) {
                let deleteBtn = row.querySelector('.delete-btn');

                // Create a new 'click' event
                var event1 = new Event('click');
                // Dispatch it.
                deleteBtn.dispatchEvent(event1);
              }
            });

            // if (value != "") {
            //   let startSelect = endTimeSelect.parentNode.parentNode.parentNode.querySelectorAll('.time-select')[0]
            //   controller.populateHours(0, startSelect, controller.splitTimeToOnlyHour(value));
            // }
            container.querySelector('.add-rate-btn').classList.add("d-none");
          } else {
            container.querySelector('.add-rate-btn').classList.remove("d-none");
          }

          if (newRateRows[j + 1]) {
            const nextRow = newRateRows[j + 1].querySelectorAll('.time-select');
            if (nextRow) {
              const startValue = parseInt(controller.splitTimeToOnlyHour(endTimeSelect.value));
              controller.populateOneHour(startValue, nextRow[0]);

              const endValue = controller.splitTimeToOnlyHour(nextRow[1].value);
              if (startValue == endValue) {
                controller.populateHours(parseInt(controller.splitTimeToOnlyHour(nextRow[0].value)) + 1, nextRow[1], null, openTime);
              } else {
                controller.populateHours(parseInt(controller.splitTimeToOnlyHour(nextRow[0].value)) + 1, nextRow[1], controller.splitTimeToOnlyHour(nextRow[1].dataset.value), openTime);
              }
              // Create a new 'change' event
              var event = new Event('change');
              // Dispatch it.
              nextRow[0].dispatchEvent(event);
            }
          }
        });
      });

      const fullContainer = container.querySelector('.full-day-price');
      let startTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[0]
      let endTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[1]

      if (startTimeFullSelect) {
        controller.populateHours(0, startTimeFullSelect, controller.splitTimeToOnlyHour(startTimeFullSelect.dataset.value));
        controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeFullSelect.value)) + 1, endTimeFullSelect, controller.splitTimeToOnlyHour(endTimeFullSelect.dataset.value));

        startTimeFullSelect.addEventListener('change', function () {
          controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeFullSelect);
        });
      }

      controller.validatePriceInput(container, '.full-day-price-input');
    });
  }

  splitTimeToOnlyHour(time) {
    if (time == undefined)
      return null

    let [hours, minutes] = time.split(':');

    return hours
  }

  populateOneHour(startHour, hourSelect, value) {
    hourSelect.innerHTML = ''; // Clear existing options

    let hour = startHour % 24;
    let option = document.createElement('option');

    // Format with leading zero
    let formattedHour = hour.toString().padStart(2, '0') + ':00';

    option.value = formattedHour;
    option.textContent = formattedHour;

    if (hour == value)
      option.selected = true;

    hourSelect.appendChild(option);
  }

  populateHours(startHour, hourSelect, value = null, stopHour = null) {
    stopHour = (stopHour == null) ? (24 + startHour) : stopHour
    hourSelect.innerHTML = ''; // Clear existing options
    for (let i = startHour; i < stopHour; i++) {
      let hour = i % 24;
      let option = document.createElement('option');

      // Format with leading zero
      let formattedHour = hour.toString().padStart(2, '0') + ':00';

      option.value = formattedHour;
      option.textContent = formattedHour;

      if (hour == value)
        option.selected = true;

      hourSelect.appendChild(option);
    }
  }

  initAddRateBtn(newSection = null) {
    const controller = this;

    const addRateButtons = newSection == null ? document.querySelectorAll('.add-rate-btn') : newSection.querySelectorAll('.add-rate-btn');
    // Add event listeners to add rate buttons
    addRateButtons.forEach(button => {
      button.addEventListener('click', function () {
        const daySection = this.closest('.day-section');
        const ratesContainer = daySection.querySelector('.rates-container');
        const addRateRow = this.closest('.button-rate');
        const rateRows = daySection.querySelectorAll('.rate-row');
        const day_name = daySection.dataset.value;

        let fullContainer = daySection.querySelector(`#${day_name}_full_content`);
        let fullTemplate;
        if (rateRows.length == 0 && fullContainer.querySelectorAll('.full-rate-column').length == 3) {
          fullTemplate = daySection.querySelector(`#${day_name}_full_template`);
          fullContainer.innerHTML = fullTemplate.innerHTML;
          controller.initDeleteFullButtons();
          controller.validatePriceInput(daySection, '.full-day-price-input');
        }

        // Clone the first rate row
        var firstRow = '';
        var lastRow;
        var newRateRow = '';
        if (rateRows.length > 0) {
          firstRow = rateRows[0]
          lastRow = rateRows[rateRows.length - 1];
          newRateRow = lastRow.cloneNode(true);

          // Insert the new rate row before the add rate button
          ratesContainer.insertBefore(newRateRow, addRateRow);

          const firstRowStartTime = firstRow.querySelectorAll('.time-select')[0];
          const previousEndTime = lastRow.querySelectorAll('.time-select')[1];
          const startTimeSelect = newRateRow.querySelectorAll('.time-select')[0];
          const endTimeSelect = newRateRow.querySelectorAll('.time-select')[1];

          let openTime = 25 + parseInt(controller.splitTimeToOnlyHour(firstRowStartTime.value));

          controller.populateOneHour(parseInt(controller.splitTimeToOnlyHour(previousEndTime.value)), startTimeSelect);
          let startValue = parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value)) + 1
          if (startValue == ((openTime % 24) - 1)) {
            controller.populateOneHour(startValue, endTimeSelect);
            daySection.querySelector('.add-rate-btn').classList.add("d-none");
          } else {
            controller.populateHours(startValue, endTimeSelect, null, openTime);
          }

          //
          previousEndTime.addEventListener('change', function () {
            const startValue = parseInt(controller.splitTimeToOnlyHour(previousEndTime.value));
            controller.populateOneHour(startValue, startTimeSelect);

            const endValue = controller.splitTimeToOnlyHour(endTimeSelect.value);
            if (startValue == endValue) {
              controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value)) + 1, endTimeSelect, null, openTime);
            } else {
              controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value)) + 1, endTimeSelect, null, openTime);
            }
            // Create a new 'change' event
            var event = new Event('change');
            // Dispatch it.
            startTimeSelect.dispatchEvent(event);
          });

          var parent = newRateRow.parentNode;
          var index = Array.prototype.indexOf.call(parent.children, newRateRow);

          startTimeSelect.addEventListener('change', function () {
            console.log(2)
            let firstRowStartTime_temp = firstRow.querySelectorAll('.time-select')[0];
            let openTime_temp;
            if (firstRowStartTime_temp != this) {
              openTime_temp = 25 + parseInt(controller.splitTimeToOnlyHour(firstRowStartTime_temp[0].value));
            } else {
              openTime_temp = 25 + parseInt(controller.splitTimeToOnlyHour(this.value));
            }

            controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeSelect, null, openTime);

            // Create a new 'change' event
            var event = new Event('change');
            // Dispatch it.
            endTimeSelect.dispatchEvent(event);
          });

          endTimeSelect.addEventListener('change', function () {
            const newRateRows = daySection.querySelectorAll('.rate-row');
            const firstRow = newRateRows[0].querySelectorAll('.time-select')[0];
            let value = firstRow.value;
            if (firstRow.value == endTimeSelect.value) {
              // newRateRows.forEach(function (row, k) {
              //   if (newRateRows.length > 1 && k > index) {
              //     let deleteBtn = row.querySelector('.delete-btn');

              //     // Create a new 'click' event
              //     var event1 = new Event('click');
              //     // Dispatch it.
              //     deleteBtn.dispatchEvent(event1);
              //   }
              // });

              // if (value != "") {
              //   let startSelect = endTimeSelect.parentNode.parentNode.parentNode.querySelectorAll('.time-select')[0]
              //   controller.populateHours(0, startSelect, controller.splitTimeToOnlyHour(value));
              // }
              daySection.querySelector('.add-rate-btn').classList.add("d-none");
            } else {
              daySection.querySelector('.add-rate-btn').classList.remove("d-none");
            }

            // if (newRateRows[j + 1]) {
            //   const nextRow = newRateRows[j + 1].querySelectorAll('.time-select');
            //   if (nextRow) {
            //     const startValue = parseInt(controller.splitTimeToOnlyHour(endTimeSelect.value));
            //     controller.populateOneHour(startValue, nextRow[0]);

            //     const endValue = controller.splitTimeToOnlyHour(nextRow[1].value);
            //     if (startValue == endValue) {
            //       controller.populateHours(parseInt(controller.splitTimeToOnlyHour(nextRow[0].value)) + 1, nextRow[1], null, openTime);
            //     } else {
            //       controller.populateHours(parseInt(controller.splitTimeToOnlyHour(nextRow[0].value)) + 1, nextRow[1], controller.splitTimeToOnlyHour(nextRow[1].dataset.value), openTime);
            //     }
            //     // Create a new 'change' event
            //     var event = new Event('change');
            //     // Dispatch it.
            //     nextRow[0].dispatchEvent(event);
            //   }
            // }
          });
        } else {
          var valueDay = daySection.dataset.value;
          var content_template = document.getElementById(`${valueDay}_template`).content.querySelector('.rate-row');
          var newRateRow = content_template.cloneNode(true);

          ratesContainer.insertBefore(newRateRow, addRateRow);

          const timeSelect = newRateRow.querySelectorAll('.time-select')
          const startTimeSelect = timeSelect[0];
          const endTimeSelect = timeSelect[1];

          controller.populateHours(0, startTimeSelect, controller.splitTimeToOnlyHour(startTimeSelect.dataset.value));

          let openTime = 25 + parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value));

          controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeSelect.value)) + 1, endTimeSelect, controller.splitTimeToOnlyHour(endTimeSelect.dataset.value), openTime);

          startTimeSelect.addEventListener('change', function () {
            console.log(3)
            //let firstRowStartTime_temp = firstRow.querySelectorAll('.time-select')[0];
            let openTime_temp;
            openTime_temp = 25 + parseInt(controller.splitTimeToOnlyHour(this.value));
            
            controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeSelect, null, openTime_temp);
            
            // Create a new 'change' event
            var event = new Event('change');
            // Dispatch it.
            endTimeSelect.dispatchEvent(event);
          });

          endTimeSelect.addEventListener('change', function () {
            const newRateRows = daySection.querySelectorAll('.rate-row');
            const firstRow = newRateRows[0].querySelectorAll('.time-select')[0];
            let value = firstRow.value;
            if (firstRow.value == endTimeSelect.value) {
            //   newRateRows.forEach(function (row, k) {
            //     if (newRateRows.length > 1 && k > j) {
            //       let deleteBtn = row.querySelector('.delete-btn');

            //       // Create a new 'click' event
            //       var event1 = new Event('click');
            //       // Dispatch it.
            //       deleteBtn.dispatchEvent(event1);
            //     }
            //   });

            //   // if (value != "") {
            //   //   let startSelect = endTimeSelect.parentNode.parentNode.parentNode.querySelectorAll('.time-select')[0]
            //   //   controller.populateHours(0, startSelect, controller.splitTimeToOnlyHour(value));
            //   // }
              daySection.querySelector('.add-rate-btn').classList.add("d-none");
            } else {
              daySection.querySelector('.add-rate-btn').classList.remove("d-none");
            }

            // if (newRateRows[j + 1]) {
            //   const nextRow = newRateRows[j + 1].querySelectorAll('.time-select');
            //   if (nextRow) {
            //     const startValue = parseInt(controller.splitTimeToOnlyHour(endTimeSelect.value));
            //     controller.populateOneHour(startValue, nextRow[0]);

            //     const endValue = controller.splitTimeToOnlyHour(nextRow[1].value);
            //     if (startValue == endValue) {
            //       controller.populateHours(parseInt(controller.splitTimeToOnlyHour(nextRow[0].value)) + 1, nextRow[1], null, openTime);
            //     } else {
            //       controller.populateHours(parseInt(controller.splitTimeToOnlyHour(nextRow[0].value)) + 1, nextRow[1], controller.splitTimeToOnlyHour(nextRow[1].dataset.value), openTime);
            //     }
            //     // Create a new 'change' event
            //     var event = new Event('change');
            //     // Dispatch it.
            //     nextRow[0].dispatchEvent(event);
            //   }
            // }
          });
        }

        controller.validatePriceInput(daySection, '.price-input');
        // Add delete button functionality
        const deleteBtn = newRateRow.querySelector('.delete-btn');
        deleteBtn.addEventListener('click', function () {
          newRateRow.remove();

          const fullContainer = daySection.querySelector(`#${day_name}_full_content`);
          if (rateRows.length == 0 && fullContainer.querySelectorAll('.full-rate-column').length == 1) {
            const fullTemplate = daySection.querySelector(`#${day_name}_full_time_template`);

            fullContainer.innerHTML = fullTemplate.innerHTML;

            let startTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[0]
            let endTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[1]
            controller.populateHours(0, startTimeFullSelect, controller.splitTimeToOnlyHour(startTimeFullSelect.dataset.value));
            controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeFullSelect.value)) + 1, endTimeFullSelect, controller.splitTimeToOnlyHour(endTimeFullSelect.dataset.value));

            startTimeFullSelect.addEventListener('change', function () {
              controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeFullSelect);
            });

            controller.validatePriceInput(daySection, '.full-day-price-input');
            controller.initDeleteFullButtons();
          }
        });

      });
    });
  }

  initFullRateBtn(newSection = null) {
    const controller = this;
    const fullRateButtons = newSection == null ? document.querySelectorAll('.full-rate-btn') : newSection.querySelectorAll('.full-rate-btn');
    fullRateButtons.forEach(button => {
      button.addEventListener('click', function () {
        const daySection = this.closest('.day-section');
        const day_name = daySection.dataset.value;
        const rateRows = daySection.querySelectorAll('.rate-row')

        let fullContainer = daySection.querySelector(`#${day_name}_full_content`);
        let fullTemplate;
        if (rateRows.length == 0) {
          fullTemplate = daySection.querySelector(`#${day_name}_full_time_template`);
        } else {
          fullTemplate = daySection.querySelector(`#${day_name}_full_template`);
        }

        fullContainer.innerHTML = fullTemplate.innerHTML;

        if (rateRows.length == 0) {
          let startTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[0]
          let endTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[1]
          controller.populateHours(0, startTimeFullSelect, controller.splitTimeToOnlyHour(startTimeFullSelect.dataset.value));
          controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeFullSelect.value)) + 1, endTimeFullSelect, controller.splitTimeToOnlyHour(endTimeFullSelect.dataset.value));

          startTimeFullSelect.addEventListener('change', function () {
            controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeFullSelect);
          });
        }

        this.parentNode.remove();
        controller.initDeleteFullButtons();
        controller.validatePriceInput(daySection, '.full-day-price-input');
      });
    });
  }

  // Initialize delete buttons function
  initDeleteButtons(newSection = null) {
    const deleteButtons = newSection == null ? document.querySelectorAll('.delete-btn') : newSection.querySelectorAll('.delete-btn');
    const controller = this;

    deleteButtons.forEach(button => {
      button.addEventListener('click', function () {
        const rateRow = this.closest('.rate-row');
        const daySection = rateRow.closest('.day-section');
        const day_name = daySection.dataset.value;
        // Only delete if there's more than one rate row
        rateRow.remove();
        const rateRows = daySection.querySelectorAll('.rate-row')
        const fullContainer = daySection.querySelector(`#${day_name}_full_content`);
        if (rateRows.length == 0 && fullContainer.querySelectorAll('.full-rate-column').length == 1) {
          const fullTemplate = daySection.querySelector(`#${day_name}_full_time_template`);

          fullContainer.innerHTML = fullTemplate.innerHTML;

          let startTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[0];
          let endTimeFullSelect = fullContainer.querySelectorAll('.full-time-select')[1];
          controller.populateHours(0, startTimeFullSelect, controller.splitTimeToOnlyHour(startTimeFullSelect.dataset.value));
          controller.populateHours(parseInt(controller.splitTimeToOnlyHour(startTimeFullSelect.value)) + 1, endTimeFullSelect, controller.splitTimeToOnlyHour(endTimeFullSelect.dataset.value));

          startTimeFullSelect.addEventListener('change', function () {
            controller.populateHours(parseInt(controller.splitTimeToOnlyHour(this.value)) + 1, endTimeFullSelect);
          });

          controller.initDeleteFullButtons();
          controller.validatePriceInput(daySection, '.full-day-price-input');
        }
      });
    });
  }

  initDeleteFullButtons(newSection = null) {
    const controller = this;
    const deleteButtons = newSection == null ? document.querySelectorAll('.delete-full-btn') : newSection.querySelectorAll('.delete-full-btn');
    deleteButtons.forEach(button => {
      button.addEventListener('click', function () {
        const fullRateRow = this.closest('.full-day-price');
        fullRateRow.innerHTML = "";

        const btnRate = fullRateRow.previousElementSibling;
        btnRate.insertAdjacentHTML('beforeend', `<div class="full-rate-row">
          <button type="button" class="full-rate-btn"><i class="fa fa-plus"></i> Full day rate</button>
        </div>`);

        controller.initFullRateBtn();
      });
    });
  }

  validateTimeRange(startSelect, endSelect) {
    const startTime = startSelect.value;
    const endTime = endSelect.value;

    // Convert to 24-hour format for comparison
    const startHour = parseInt(startTime.split(':')[0]);
    const endHour = parseInt(endTime.split(':')[0]);

    if (endHour <= startHour) {
      alert('End time must be after start time.');
      // Reset to default values
      startSelect.selectedIndex = 0;
      endSelect.selectedIndex = 0;
    }
  }

  validatePriceInput(containerRow, className) {
    const inputFields = containerRow.querySelectorAll(className);

    inputFields.forEach(inputField => {
      inputField.addEventListener('input', function (event) {
        this.value = this.value.replace(/[^0-9]/g, '');
      });
    })
  }

  initSelect2Fields() {
    $('.form select.select2').each(function () {
      var paramsChange = {
        //theme: "bootstrap",
        tags: $(this).data('tags') || false,
        placeholder: $(this).data('placeholder')
      };

      if ($(this).data('max-selection') != undefined) {
        paramsChange['maximumSelectionLength'] = $(this).data('max-selection')
      };

      $(this).select2(paramsChange);
    });

    $("select.select2-wo-order").on("select2:select", function (evt) {
      var element = evt.params.data.element;
      var $element = $(element);

      $element.detach();
      $(this).append($element);
      $(this).trigger("change");
    });

    $("select.select2-wo-order").on('select2:open', function (e) {
      $('.select2-dropdown').css({ "font-family": 'Montserrat' });
    });
  }

  delay(callback, ms) {
    var timer = 0;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  minMaxCapacityChange() {
    // Price
    $("#venue_room_min_capacity").on("keyup change", this.delay(function (e) {
      var min_capacity = $(this).val()
      $("#venue_room_max_capacity").attr('min', min_capacity)
      var value = parseInt(min_capacity)
      if ($("#venue_room_prices_attributes_0_unit_type").val() == "pax") {
        var $min_inputs = $("#venue_room_prices_attributes_0_min_unit")
        var $max_inputs = $("#venue_room_prices_attributes_0_max_unit")
        var min_input_value = parseInt($min_inputs.val())
        $min_inputs.attr('min', min_capacity)
        $max_inputs.attr('min', min_capacity)
        if (min_input_value < value) {
          $min_inputs.val(value).trigger("change")
        }
      }

      var $packages = $("#packages").find(".package-fields")
      if ($packages.length > 0) {
        $packages.each(function (i, obj) {
          var $obj = $(obj)
          var $min_capacity = $($obj.find("input[name*='min_capacity']")[0])
          var $max_capacity = $($obj.find("input[name*='max_capacity']")[0])
          $min_capacity.attr('min', min_capacity)
          $max_capacity.attr('min', min_capacity)
          var min_input_value = parseInt($min_capacity.val())
          if (min_input_value < value) {
            $min_capacity.val(value)
          }
          // var unit_type = $($(obj).find("select[name*='unit_type']")[0]).val()
          // if (unit_type == "pax") {
          //   var $min_input = $($(obj).find("input[name*='min_unit']")[0])
          //   var $max_input = $($(obj).find("input[name*='max_unit']")[0])
          //   var min_input_value = parseInt($min_input.val())
          //   $min_input.attr('min', min_capacity)
          //   $max_input.attr('min', min_capacity)
          //   if (min_input_value < value) {
          //     $min_input.val(value)
          //   }
          // }
        })
      }
    }, 1000))

    $("#venue_room_max_capacity").on("keyup change", this.delay(function (e) {
      var max_capacity = $(this).val()
      var value = parseInt(max_capacity)
      if ($("#venue_room_prices_attributes_0_unit_type").val() == "pax") {
        var $min_inputs = $("#venue_room_prices_attributes_0_min_unit")
        var $max_inputs = $("#venue_room_prices_attributes_0_max_unit")
        var max_input_value = parseInt($max_inputs.val())
        $min_inputs.attr('max', max_capacity)
        $max_inputs.attr('max', max_capacity)
        if (max_input_value > value) {
          $max_inputs.val(value).trigger("change")
        }
      }

      var $packages = $("#packages").find(".package-fields")
      if ($packages.length > 0) {
        $packages.each(function (i, obj) {
          var $obj = $(obj)
          var $min_capacity = $($obj.find("input[name*='min_capacity']")[0])
          var $max_capacity = $($obj.find("input[name*='max_capacity']")[0])
          var max_input_value = parseInt($max_capacity.val())
          $min_capacity.attr('min', max_capacity)
          $max_capacity.attr('min', max_capacity)
          if (max_input_value > value) {
            $max_capacity.val(value).trigger("change")
          }

          // var obj = $(obj)
          // var unit_type = $($(obj).find("select[name*='unit_type']")[0]).val()
          // if (unit_type == "pax") {
          //   var $min_input = $($(obj).find("input[name*='min_unit']")[0])
          //   var $max_input = $($(obj).find("input[name*='max_unit']")[0])
          //   var max_input_value = parseInt($max_input.val())
          //   $min_input.attr('max', max_capacity)
          //   $max_input.attr('max', max_capacity)
          //   if (max_input_value > value) {
          //     $max_input.val(value)
          //   }
          // }
        })
      }
    }, 1000))

    $(document).on('change keyup', '.min_capacity_package', this.delay(function (e) {
      var min_capacity = $(this).val()
      var $parent = $(this).parents('.package-fields')
      var $unit_type = $parent.find("select[name*='unit_type']")
      $parent.find(".max_capacity_package").attr('min', min_capacity)
      var value = parseInt(min_capacity)
      if ($unit_type.val() == "pax") {
        var $min_inputs = $parent.find("input[name*='min_unit']")
        var $max_inputs = $parent.find("input[name*='max_unit']")
        var min_input_value = parseInt($min_inputs.val())
        $min_inputs.attr('min', min_capacity)
        $max_inputs.attr('min', min_capacity)
        $min_inputs.data('min', min_capacity)
        $max_inputs.data('min', min_capacity)
        if (min_input_value < value) {
          $min_inputs.val(value).trigger("change")
        }
      }
    }, 1000))

    $(document).on('change keyup', '.max_capacity_package', this.delay(function (e) {
      var max_capacity = $(this).val()
      var $parent = $(this).parents('.package-fields')
      var $unit_type = $parent.find("select[name*='unit_type']")
      var value = parseInt(max_capacity)
      if ($unit_type.val() == "pax") {
        var $min_inputs = $parent.find("input[name*='min_unit']")
        var $max_inputs = $parent.find("input[name*='max_unit']")
        var max_input_value = parseInt($max_inputs.val())
        $min_inputs.attr('max', max_capacity)
        $max_inputs.attr('max', max_capacity)
        $min_inputs.data('max', max_capacity)
        $max_inputs.data('max', max_capacity)
        if (max_input_value > value) {
          $max_inputs.val(value).trigger("change")
        }
      }
    }, 1000))
  }

  bindingDiscountLimit() {
    // Discount
    $("#venue_room_prices_attributes_0_min_unit").on("keyup change", this.delay(function (e) {
      var $discount_limit_unit = $("#price_discounts").find("input[name*='discount_limit_unit']")
      var value = parseInt($(this).val())
      $discount_limit_unit.attr('min', $(this).val())
      $discount_limit_unit.each(function (i, el) {
        el = $(el)
        var discount_value = parseInt(el.val())
        if (discount_value < value) {
          el.val(value).trigger("input")
        }
      })
    }, 1000))
    $("#venue_room_prices_attributes_0_max_unit").on("keyup change", this.delay(function (e) {
      var $discount_limit_unit = $("#price_discounts").find("input[name*='discount_limit_unit']")
      var value = parseInt($(this).val())
      $discount_limit_unit.attr('max', value)
      $discount_limit_unit.each(function (i, el) {
        el = $(el)
        var discount_value = parseInt(el.val())
        if (discount_value > value) {
          el.val(value).trigger("input")
        }
      })
    }, 1000))
  }

  bindingPackageButton() {
    let classDefine = this

    //
    var $packages = $("#packages").find(".package-fields")
    if ($packages.length > 0) {
      $('#package .form-group--button .image-wrapper').hide()
      $('#package .form-group--button').css({ "-webkit-box-alight": "start", "-ms-flex-alight": "start", "align-items": "flex-start" })

      $packages.each(function (i, obj) {
        var obj = $(obj)
        var index = obj[0].dataset["index"]
        classDefine.initCropper(obj.find('#photo-input' + index).get(0))
      })
    }

    $('#packages')
      .on('cocoon:after-insert', function (e, added_task) {
        var index = $('#packages').find('.package-fields').length
        added_task.find('#media-photo-input-wrapper').attr("id", "media-photo-input-wrapper" + index);
        added_task.find('#button-add-photo').attr("id", "button-add-photo" + index);
        added_task.find('#photo-input').attr("id", "photo-input" + index);
        added_task.find('#photo-x').attr("id", "photo-x" + index);
        added_task.find('#photo-y').attr("id", "photo-y" + index);
        added_task.find('#photo-h').attr("id", "photo-h" + index);
        added_task.find('#photo-w').attr("id", "photo-w" + index);
        added_task.find('#photo-photo-image-result').attr("id", "photo-photo-image-result" + index);
        added_task.find('#photo-photo-preview').attr("id", "photo-photo-preview" + index);
        added_task.find('#edit-photo-image-package').attr("id", "edit-photo-image-package" + index);
        added_task.find('#media-photo-input-preview').attr("id", "media-photo-input-preview" + index);
        added_task.find('#media-photo-input-preview-content').attr("id", "media-photo-input-preview-content" + index);
        added_task.find('#saving-photo-crop').attr("id", "saving-photo-crop" + index);

        $('#photo-input' + index).attr({
          'data-upload-button': "button-add-photo" + index,
          'data-input-target-x': "photo-x" + index,
          'data-input-target-y': "photo-y" + index,
          'data-input-target-h': "photo-h" + index,
          'data-input-target-w': "photo-w" + index,
          'data-image-wrapper': "photo-photo-image-wrapper" + index,
          'data-photo-preview': "photo-photo-preview" + index,
          'data-edit-button': "edit-photo-image-package" + index,
          'data-media-input-preview-wrapper': "media-photo-input-preview" + index,
          'data-media-input-preview-content': "media-photo-input-preview-content" + index,
          'data-saving-crop': "saving-photo-crop" + index,
          'data-media-input-wrapper': "media-photo-input-wrapper" + index,
          'data-photo-image-result': "photo-photo-image-result" + index
        })

        classDefine.initCropper($('#photo-input' + index).get(0))
        added_task.data("index", index)
        added_task.find('.package-index').html(index)

        if (index == 1) {
          $('#package .form-group--button .image-wrapper').hide()
          $('#package .form-group--button').css({ "-webkit-box-alight": "start", "-ms-flex-alight": "start", "align-items": "flex-start" })
        }

        // Initialize package min unit
        // var min_unit = added_task.find("input[name*='min_unit']")[0]
        // var max_unit = added_task.find("input[name*='max_unit']")[0]
        // var price_min_unit = $("#venue_room_min_capacity").val()
        // var price_max_unit = $("#venue_room_max_capacity").val()
        // $(min_unit).attr('min', price_min_unit)
        // $(min_unit).attr('max', price_max_unit)
        // $(min_unit).val(price_min_unit)
        // $(max_unit).attr('min', price_min_unit)
        // $(max_unit).attr('max', price_max_unit)
      })
  }

  initCropper(input) {
    cropper(input)
  }

  photosAdded() {
    let classDefine = this

    if ($('#photos-upload-wrapper').length > 0) {
      $(document).on('click', '.close-media-input-preview', function () {
        classDefine.showHidePreview('hide')
        // showHideSavingForm('show');
        $('#input-btn-add-photo').removeData('target')

        if ($(this).attr('id') == 'close-button') {
          // clear all field by checking if there are value on photo remote url or not
          var photo_remote = $('#' + classDefine.id_target)
          if (photo_remote.data('new-record') == true && photo_remote.val() == '') {
            photo_remote.parents('.nested-fields').first().remove()
          }
        }
      })

      $(document).on('click', '.btn-add-photo', function () {
        $('#input-btn-add-photo').removeData('target')
        $('#input-btn-add-photo').click()
      })

      $(document).on('change', '#input-btn-add-photo', function () {
        classDefine.clearAllVariable()
        classDefine.clearSelectorImage()
        if ($(this).data('target') !== undefined) {
          classDefine.insertPhotoModal('#' + $(this).data('target'))
          classDefine.showHidePreview('show')
          classDefine.showHideSavingCrop('hide')
        } else {
          $('#pseudo-button-add-photo').click()
        }

        $(this).val('')
      })

      $(document).on('click', '.edit-photo-image-venue', function (e) {
        e.preventDefault()
        $('#photo-image-wrapper' + $(this).data('target')).data('action', 'edit')
        $('#input-btn-add-photo').data('target', $(this).data('target'))
        $('#input-btn-add-photo').click()
      })

      $(document).on('click', '#saving-crop', function () {
        classDefine.target_x.val(classDefine.value_x)
        classDefine.target_y.val(classDefine.value_y)
        classDefine.target_h.val(classDefine.value_h)
        classDefine.target_w.val(classDefine.value_w)
        $('#input-btn-add-photo').removeData('target')
        $('#' + classDefine.id_target).val(classDefine.photo_remote_link)
        classDefine.target_preview.attr('src', classDefine.cropperElement.getCroppedCanvas().toDataURL())
        $('#photo-image-wrapper' + classDefine.id_target).show()

        var html = "<figure class='thumbnail-item item'>" +
          "<img src='" + classDefine.cropperElement.getCroppedCanvas().toDataURL() + "' class='img-fluid thumbnail-image'>" +
          "</figure>"
        var index = 0
        if ($('#photo-image-wrapper' + classDefine.id_target).data('action') == "edit") {
          index = $('#photo-image-wrapper' + classDefine.id_target).data('index')
        } else {
          index = $('#photos').find('.photo-fields:visible').length - 1
          if (index == 0) {
            $('#is_primary' + classDefine.id_target).val(true)
            $('#photo-image-wrapper' + classDefine.id_target).find('.photo-image-star-wrapper').show()
          }
        }
        var $parent = $('#photo-image-wrapper' + classDefine.id_target).parents('.photo-fields')
        $parent.data("index", index)
        $parent.find("[data-index]").data("index", index)

        if ($('#photos').find('.photo-fields:visible').length == 1) {
          $(".thumbnail-slider").slick('slickAdd', html, 0)
        } else {
          $(".thumbnail-slider").slick('slickAdd', html, index - 1)
        }

        if ($('#photo-image-wrapper' + classDefine.id_target).data('action') == "edit") {
          $(".thumbnail-slider").slick('slickRemove', index)
        }
        $(".thumbnail-container--room").addClass("uploaded")
      })

      $('#photos')
        .on('cocoon:after-insert', function (e, added_task) {
          var target = $('#photos .photo-remote-url').last().attr('id')
          classDefine.insertPhotoModal('#' + target)
          classDefine.showHidePreview('show')
          classDefine.showHideSavingCrop('hide')

          added_task.on('click', function (e) {
            if (e.target.id.includes("photo_preview_")) {
              $("#modalRoomPackage").modal("show")
              $(".thumbnail-slider").slick("slickGoTo", $(e.target).data('index'), true)
              $("#modalRoomPackage #setPrimary").data('index', $(e.target).data('index'))
            }
          })
          // showHideSavingForm('hide');
        })
        .on("cocoon:after-remove", function (e, task) {
          var index = task.data('index')
          var $photos_fields = $('#photos').find('.nested-fields:visible')
          if ($photos_fields.length > 0) {
            $photos_fields.each(function (i, obj) {
              var old_index = $(obj).data("index")
              $(obj).data("index", old_index - 1)
              $(obj).find("[data-index]").data("index", old_index - 1)
            })
          }

          if (task.find("input[name*='is_primary']").val() == "true") {
            var first_photo = $('#photos').find('.photo-fields:visible').eq(0)
            first_photo.find("input[name*='is_primary']").val(true)
            first_photo.find('.photo-image-star-wrapper').show()
          }

          $(".thumbnail-slider").slick('slickRemove', index)
        })

    }
  }

  //for make sure previous variables not includes
  clearAllVariable() {
    this.id_target, this.target_x, this.target_y, this.target_h, this.target_w,
      this.target_preview, this.value_x, this.value_y, this.value_h, this.value_w,
      this.photo_remote_link = null
  }

  // clear and prepared input
  clearSelectorImage() {
    this.image_selector.attr('src', '')

    if (this.image_selector.hasClass('cropper-hidden')) {
      this.cropperElement.destroy()
    }

    this.image_selector.removeData('id')
  }

  setStatusSelector(state) {
    if (state === undefined) {
      state = 'loading';
    }

    var text = 'Uploading...';

    if (state === 'loading') {
      text = 'Uploading...';
    } else if (state === 'success') {
      text = ''
    } else {
      text = state;
    }

    text = (text == 'Upload Too Large') ? '<span style="color: red;"> File uploaded has exceeded 10MB </span>' : text;
    this.status_selector.html('<p>' + text + '</p>')
  }

  showHidePreview(state) {
    if (state === undefined) {
      state = 'hide';
    }

    if (state === 'hide') {
      $('#media-input-preview').hide()
      $('#media-input-wrapper').show()
    } else {
      $('#media-input-preview').show()
      $('#media-input-wrapper').hide()
    }
  }

  showHideSavingCrop(state) {
    if (state === undefined) {
      state = 'hide';
    }

    if (state === 'hide') {
      $('#saving-crop').hide()
    } else {
      $('#saving-crop').show()
    }
  }

  showHideSavingForm(state) {
    if (state === undefined) {
      state = 'hide';
    }

    if (state === 'hide') {
      $('#save-form').hide()
    } else {
      $('#save-form').show()
    }
  }

  insertPhotoModal(input) {
    let classDefine = this

    classDefine.id_target = $(input).attr('id');
    classDefine.setStatusSelector('loading');

    var formData = new FormData();
    formData.append('file', $('#input-btn-add-photo')[0].files[0])

    $.ajax({
      type: 'POST',
      url: '/venue_photo_cache_uploader/upload',
      processData: false,
      contentType: false,
      data: formData,
      success: function (data) {
        classDefine.photo_remote_link = $(input).data('base-url') + '/shrine/cache/' + data.id;

        classDefine.setStatusSelector('success')
        classDefine.buildCropper()
      },
      error: function (error) {
        if (error.status === 413) {
          classDefine.setStatusSelector('Upload Too Large')
        } else {
          classDefine.setStatusSelector(error.responseText)
        }
      }
    })
  }

  buildCropper() {
    let classDefine = this

    classDefine.target_x = $('#x' + classDefine.id_target);
    classDefine.target_y = $('#y' + classDefine.id_target);
    classDefine.target_h = $('#h' + classDefine.id_target);
    classDefine.target_w = $('#w' + classDefine.id_target);
    classDefine.target_preview = $('#photo_preview' + classDefine.id_target);

    classDefine.image_selector.attr('src', classDefine.photo_remote_link);
    classDefine.image_selector.attr('crossorigin', 'anonymous');

    this.cropperElement = new Cropper(image, {
      aspectRatio: 8 / 6,
      zoomable: false,
      scalable: false,
      rotatable: false,
      crop(event) {
        classDefine.showHideSavingCrop('show')
        // showHideSavingForm('hide')
        classDefine.value_x = event.detail.x;
        classDefine.value_y = event.detail.y;
        classDefine.value_h = event.detail.height;
        classDefine.value_w = event.detail.width;
      }
    })
  }

  bindingAddDiscount() {
    let classDefine = this

    $('.btn-discount').on('click', function () {
      if ($('#discount_summary').hasClass('d-none')) {
        $('#discount_summary').removeClass('d-none')
      }
    })

    $('#price_discounts')
      .on('cocoon:after-insert', function () {
        var index = $(this).find('.discount-fields').length
        var unit_type = $(this).parents(".price-wrapper").find('.unit_type_changed').val()
        // Initialize data attribute
        $(this).find(".discount-fields:last").find('.discount-unit-type').html('(' + unit_type + ')')
        $(this).find(".discount-fields:last").data("index", index)
        $(this).find(".discount-fields:last").find('.discount-index').html(index)
        $(this).find(".discount-fields:last").find('input, select').data('id', index)

        // Initialize discount limit unit
        // var $discount_limit_unit = $(this).find(".discount-fields:last").find("input[name*='discount_limit_unit']")
        // var price_min_unit = $("#venue_room_prices_attributes_0_min_unit").val()
        // var price_max_unit = $("#venue_room_prices_attributes_0_max_unit").val()
        // $discount_limit_unit.attr('min', price_min_unit)
        // $discount_limit_unit.attr('max', price_max_unit)
        // $discount_limit_unit.attr('value', price_min_unit)

        classDefine.bindingDiscountInputs()
        classDefine.appendSummaryDiscount(index, unit_type)
      })
      .on("cocoon:after-remove", function (e, task) {
        var index = task.data('index')
        classDefine.removeSummaryDiscount(index)
      })
  }

  bindingDiscountInputs() {
    $('#price_discounts').find('input').each(function () {
      $(this).on('input', function (e) {
        var value = $(this).val()
        var id = $(this).data('id')
        var attr = $(this).data('attr')
        if (attr == "discount") {
          var result = parseFloat(value).toFixed(2)
          var discount_type = $(this).closest('.form-group').find("select[data-attr='discount']").val()
          if (discount_type == '$') {
            var currency = $('#venue_room_prices_attributes_0_currency').val();
            $('#summary_discount_' + id + ' .summary-discount').html(currency + result)
          } else {
            $('#summary_discount_' + id + ' .summary-discount').html(result + '%')
          }
        } else {
          $('#summary_discount_' + id + ' .summary-discount-' + attr).html(value)
        }
      })
    })

    $('#price_discounts').find('select').each(function () {
      $(this).on('change', function (e) {
        var value = $(this).val()
        var id = $(this).data('id')
        var attr = $(this).data('attr')
        if (attr == "discount") {
          var discount_value = $(this).closest('.form-group').find("input[data-attr='discount']").val()
          var result = parseFloat(discount_value).toFixed(2)
          if (!isNaN(result)) {
            if (value == '$') {
              var currency = $('#venue_room_prices_attributes_0_currency').val();
              $('#summary_discount_' + id + ' .summary-discount').html(currency + result)
            } else {
              $('#summary_discount_' + id + ' .summary-discount').html(result + '%')
            }
          }
        }
      })
    })
  }

  appendSummaryDiscount(index, unit_type) {
    $('#discount_summary').append("<p id='summary_discount_" + index + "' class='text'>" +
      "- Minimum of <span class='bold'><span class='summary-discount-limit-unit'></span> <span class='summary-discount-unit-type'>" + unit_type + "(s)</span></span> rental to enjoy " +
      "<span class='bold'><span class='summary-discount'></span> discount</span>")
  }

  removeSummaryDiscount(index) {
    $('#summary_discount_' + index).remove()
  }

  appendExistingAmenity() {
    for (let amenityDOM of this.amenityTargets) {
      if (amenityDOM.dataset['id']) {
        this.tags.push(amenityDOM.dataset['id'])
      }
    }
  }

  customTags() {
    let classDefine = this
    let input = document.querySelector('.input-tags')

    if (input !== null) {
      input.addEventListener('keyup', function (event) {
        const keyPressedIsEnter = event.key === 'Enter'

        if ($("#venue_room_other_amenities > option").length > 4) return
        if (keyPressedIsEnter) {
          input.value.split(',').forEach(function (tag, index) {
            tag = tag.trim()
            if (tag == "") return
            var optionExists = ($("#venue_room_other_amenities option[value='" + tag + "']").length > 0)
            if (optionExists) return

            classDefine.tags.push(tag.trim())
          })

          classDefine.updateTags()
          input.value = ''
        }
      })
    }
  }

  updateTags() {
    let classDefine = this
    classDefine.clearTags()

    classDefine.tags.slice().reverse().forEach(tag => {
      document.querySelector('.tag-container').prepend(classDefine.createTag(tag))
      // Add tag to select option
      var optionExists = ($("#venue_room_other_amenities option[value='" + tag + "']").length > 0)
      if (!optionExists) {
        $('#venue_room_other_amenities').prepend("<option selected='selected' value='" + tag + "'>" + tag + "</option>")
      }
    })
  }

  createTag(tag) {
    // Preview Badge
    const div = document.createElement('div')
    div.classList.add('badge', 'amenties')
    const span = document.createElement('span')
    span.innerHTML = tag
    const i = document.createElement('i')
    i.classList.add('fa', 'fa-times-circle', 'close')
    i.setAttribute('data-id', tag)
    i.setAttribute('data-action', 'click->users--venue-rooms--form#removeTags')
    i.setAttribute('data-users--venue-rooms--form-target', 'amenity')
    span.append(i)
    div.append(span)

    return div
  }

  removeTags(event) {
    const buttonX = event.currentTarget
    const id = buttonX.dataset.id
    const index = this.tags.indexOf(id)

    // Remove tag inside tag container
    this.tags.splice(index, 1)

    // Remove option from select
    $("#venue_room_other_amenities option[value='" + id + "']").remove()

    this.updateTags()
  }

  clearTags() {
    document.querySelector('.tag-container')
      .querySelectorAll('.amenties')
      .forEach(tagElement => tagElement.remove())
  }

  disabledEnterForm() {
    $('#form_listing').on('keyup keypress', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault()
        return false
      }
    })
  }

  modalDeleteSimpleForm() {
    $('#modalDeleteConfirmation').on('show.bs.modal', function (e) {
      //get id attribute of the clicked element
      var link_input_id = $(e.relatedTarget).find('input').attr('id')
      $(e.currentTarget).find('input').val(link_input_id)
    })

    $('button#modal_delete_it').on('click', function (e) {
      var link_id = $(this).siblings("input").val()
      $('#' + link_id).siblings("a").trigger('click')
      if ($('#price_discounts').find('.discount-fields').length == 1) {
        $('#discount_summary').addClass('d-none')
      }
    })
  }

  loadSummernoteEditor() {
    $(".textarea-description").on('keypress', function (e) {
      if (this.value.length > 600) {
        return false
      }
      // If the user has pressed enter
      if ((e.keyCode == 10 || e.keyCode == 13)) {
        e.preventDefault()
        this.value = this.value + "\n"
      }

      $(".limit-character").html((600 - this.value.length))
    })
    $(".textarea-description").trigger('keypress')

    $('.form-control--text-editor').each(function () {
      $(this).summernote({
        tooltip: false,
        toolbar: [['style', ['highlight', 'bold', 'italic', 'underline', 'clear']], ['para', ['ul', 'ol']]],
        callbacks: {
          onPaste: function (e) {
            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('text/html')

            e.preventDefault()

            var div = $('<div>')
            div.append(bufferText)

            div.find('iframe, style, script, applet, embed, noframes, noscript').remove()
            div.find('*').removeAttr('style class id')

            setTimeout(function () {
              document.execCommand('insertHtml', false, div.html())
            }, 10)
          }
        }
      })
    })

    $("#packages").on('keypress', ".textarea-description-enter-key", function (e) {
      // If the user has pressed enter
      if ((e.keyCode == 10 || e.keyCode == 13)) {
        e.preventDefault()
        this.value = this.value + "\n"
      }
    })
  }

  unitTypeChange() {
    let classDefine = this

    $(document).on('change', '.unit_type_changed', function () {
      var nested_wrapper = $(this).parents('.nested-fields').first()
      var value = $(this).val()
      classDefine.changeStateUnitType(nested_wrapper, value)
    })

    $('.price-fields').each(function () {
      var nested_wrapper = $(this)
      var value = $(this).find('.unit_type_changed').first().val()

      classDefine.changeStateUnitType(nested_wrapper, value)
    })

    $('.package-fields').each(function () {
      var nested_wrapper = $(this)
      var value = $(this).find('.unit_type_changed').first().val()

      classDefine.changeStateUnitType(nested_wrapper, value)
    })
  }

  changeStateUnitType(wrapper, value) {
    if (value == 'minimum spend') {
      wrapper.find('.hide-minimum-spend').hide()
      wrapper.find('.show-minimum-spend').show()
      wrapper.parents(".price-wrapper").find('#price_discounts').hide()
      wrapper.parents(".price-wrapper").find('#discount_summary').hide()
      wrapper.parents(".price-wrapper").find('.btn-discount').hide()
      $(wrapper.find("input[name*='min_unit']").get(0)).val(1)
      // $(wrapper.find("input[name*='min_unit']").get(0)).removeAttr('required')
      // $(wrapper.find("input[name*='min_unit']").get(0)).removeAttr('min')
      // $(wrapper.find("input[name*='min_unit']").get(0)).removeAttr('max')
      $(wrapper.find("input[name*='max_unit']").get(0)).val("")
      // $(wrapper.find("input[name*='max_unit']").get(0)).removeAttr('required')
      // $(wrapper.find("input[name*='max_unit']").get(0)).removeAttr('min')
      // $(wrapper.find("input[name*='max_unit']").get(0)).removeAttr('max')
    } else {
      wrapper.find('.hide-minimum-spend').show()
      wrapper.find('.show-minimum-spend').hide()
      wrapper.find('.pax-hour-label').html(value)
      wrapper.find('.pax-min-label').html(value)
      wrapper.find('.pax-max-label').html(value)
      wrapper.parents(".price-wrapper").find('.discount-unit-type').html('(' + value + ')')
      wrapper.parents(".price-wrapper").find('.summary-discount-unit-type').html(value + '(s)')
      wrapper.parents(".price-wrapper").find('#price_discounts').show()
      wrapper.parents(".price-wrapper").find('#discount_summary').show()
      wrapper.parents(".price-wrapper").find('.btn-discount').show()
      // var $min_input = $(wrapper.find("input[name*='min_unit']").get(0))
      // var $max_input = $(wrapper.find("input[name*='max_unit']").get(0))
      // $min_input.attr('required', 'required')
      // $max_input.attr('required', 'required')
      // if (value == "pax") {
      //   var min_input_value = parseInt($("#venue_room_min_capacity").val())
      //   var max_input_value = parseInt($("#venue_room_max_capacity").val())
      //   var min_value = parseInt($min_input.val())
      //   var max_value = parseInt($max_input.val())
      //   $min_input.attr('min', min_input_value)
      //   $min_input.attr('max', max_input_value)
      //   $max_input.attr('min', min_input_value)
      //   $max_input.attr('max', max_input_value)
      //   if (min_value < min_input_value) {
      //     $min_input.val(min_input_value).trigger("change")
      //   }
      //   if (max_value > max_input_value) {
      //     $max_input.val(max_input_value).trigger("change")
      //   }
      // } else {
      //   $min_input.attr('min', 1)
      //   $min_input.attr('max', '')
      //   $max_input.attr('min', 1)
      //   $max_input.attr('max', '')
      // }
    }
  }

  bindingImageUpload() {
    $(".thumbnail-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      prevArrow: $(".thumbnail-prev"),
      nextArrow: $(".thumbnail-next"),
      infinite: true,
      adaptiveHeight: true,
    })

    var $photos_fields = $('#photos').find('.nested-fields')
    if ($photos_fields.length > 0) {
      $photos_fields.find('img').each(function (i, obj) {
        var html = "<figure class='thumbnail-item item'>" +
          "<img src='" + $(obj).attr('src') + "' class='img-fluid thumbnail-image'>" +
          "</figure>"

        $(".thumbnail-slider").slick('slickAdd', html)
      })
    }

    $(".thumbnail-inner-wrapper").on('click', function (e) {
      if (e.target.id.includes("photo_preview_")) {
        $("#modalRoomPackage").modal("show")
        $(".thumbnail-slider").slick("slickGoTo", $(e.target).data('index'), true)
        $("#modalRoomPackage #setPrimary").data('index', $(e.target).data('index'))
      }
    })

    $("#modalRoomPackage").on("shown.bs.modal", function (e) {
      $(".thumbnail-slider").slick("setPosition")
    })

    $('.thumbnail-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      $("#modalRoomPackage #setPrimary").data('index', currentSlide)
    })

    $("#modalRoomPackage #setPrimary").on('click', function (e) {
      var index = $(this).data('index')
      $("#photos").find("input[name*='is_primary']").each(function (i, obj) {
        $(obj).val(false)
        $(obj).parents('.photo-fields').find('.photo-image-star-wrapper').hide()
        if (index == $(obj).data('index')) {
          $(obj).val(true)
          $(obj).parents('.photo-fields').find('.photo-image-star-wrapper').show()
        }
      })
    })
  }
}
